import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { State } from "../store/interfaces";

import { StatusCodes } from "http-status-codes";
import { DecisionTimeFrameService } from "../api/services/decisionTimeFrame";
import {
  loadDecisionTimeFrameErrorAction,
  loadDecisionTimeFrameRequestAction,
  loadDecisionTimeFrameSuccessAction,
} from "../store/reducers/decisionTimeFrame";
import { DecisionTimeFrame } from "../api/models/decisionTimeFrame";

export const useDecisionTimeFrame = (
  decisionTimeFrameService: DecisionTimeFrameService
) => {
  const intent = useSelector((state: State) => state.decisionTimeFrame);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadDecisionTimeFrame = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadDecisionTimeFrameRequestAction());
    try {
      // console
    } catch (error) {
      return dispatch(loadDecisionTimeFrameErrorAction());
    }
  };

  const createDecisionTimeFrame = async (
    data: DecisionTimeFrame,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await decisionTimeFrameService.createDecisionTimeFrame({
        ...data,
      });
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError("Unable to update details");
    }
    setUpdating(false);
  };

  const updateDecisionTimeFrame = async (
    data: DecisionTimeFrame,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await decisionTimeFrameService.updateDecisionTimeFrame(
        data,
        id
      );
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError("Unable to update details");
    }
    setUpdating(false);
  };

  return {
    loadDecisionTimeFrame,
    createDecisionTimeFrame,
    updateDecisionTimeFrame,
    updating,
    updateError,
  };
};
